import { render, staticRenderFns } from "./customerODM.vue?vue&type=template&id=2544a456&scoped=true&"
import script from "./customerODM.vue?vue&type=script&lang=js&"
export * from "./customerODM.vue?vue&type=script&lang=js&"
import style0 from "./customerODM.vue?vue&type=style&index=0&id=2544a456&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544a456",
  null
  
)

export default component.exports